<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-container fluid class="m-0 vh-100">
      <div>
        <Logo :logoProps="logo" />
      </div>
      <!-- v-if="taskStatus != 0" -->
      <div id="training">
        <b-row class="mb-4 pt-2 px-5 pb-5">
          <b-col cols="12">
            <b-card class="mb-3" style="height: calc(100vh - 150px)">
              <div
                v-for="(slide, index) in slidesWithSelectedLanguage"
                :key="index"
              >
                <b-img
                  v-if="currentSlideIndex == index"
                  :src="slide.url"
                  :alt="slide.title"
                  fluid
                  class="text-left animate-slide-from-left"
                  style="height: calc(100vh - 180px)"
                ></b-img>
              </div>
            </b-card>

            <b-row>
              <b-col class="text-left" cols="5">
                <div class="mt-3">
                  <b-button-group>
                    <b-button
                      variant="warning"
                      v-if="currentSlideIndex > 0"
                      @click="currentSlideIndex = 0"
                      >{{ $t("training.toFirstSlide") }}</b-button
                    >
                    <b-button
                      v-if="!isLinkForm"
                      variant="outline-danger"
                      @click="onBack"
                      >{{ $t("training.toDashboard") }}</b-button
                    >
                    <b-button
                      variant="outline-primary"
                      :disabled="inTransistion"
                      v-if="currentSlideIndex != 0"
                      @click="previousSlide"
                      >{{ $t("training.slide") }}
                      {{ currentSlideIndex }}</b-button
                    >
                  </b-button-group>
                </div>
              </b-col>
              <b-col cols="2">
                <span>
                  {{ $t("training.viewing") }}
                  <b-badge variant="dark">{{
                    currentSlideIndex +
                      1 +
                      "/" +
                      slidesWithSelectedLanguage.length
                  }}</b-badge>
                </span>
              </b-col>
              <b-col cols="5" class="text-right">
                <div class="mt-3">
                  <b-button class="text-right" @click="toggleFullScreen">
                    <font-awesome-icon icon="compress" />
                  </b-button>
                  <b-button-group>
                    <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="nextslide"
                      v-if="
                        currentSlideIndex + 1 !=
                          slidesWithSelectedLanguage.length
                      "
                      >{{ $t("training.nextSlide") }}</b-button
                    >
                    <!-- <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="onCompleteTraining"
                      v-if="(currentSlideIndex+1) == slides.length"
                    >Complete</b-button>-->
                    <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="onOpenSignatureModal"
                      v-if="
                        currentSlideIndex + 1 ==
                          slidesWithSelectedLanguage.length
                      "
                      >{{ $t("training.next") }}</b-button
                    >
                  </b-button-group>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <!-- <div class="my-5" v-if="taskStatus == 0 && form.isShowFormIntro">
        <h1 class="mb-4">{{formTitle}}</h1>
        <p v-html="sanitizeHtml(pageIntroText)"></p>
        <b-button variant="outline-primary" class="mr-2" @click="onStartTraining">START NOW</b-button>
        <b-button @click="onBack">I'll do it later</b-button>
      </div>-->
    </b-container>

    <!-- signature modal -->
    <b-modal
      v-model="showSignatureModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      modal-header-close="No"
      scrollable
      :title="signatureFormTitle ? signatureFormTitle[selectedLanguage] : ''"
      size="xl"
    >
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" @click="resetModal">{{
          $t("training.close")
        }}</b-button>
        <b-button v-if="subTaskStatus != 4" @click="onValidateSignature">{{
          $t("training.complete")
        }}</b-button>
      </template>
      <div>
        <SignaturePad
          v-if="showSig"
          class="p-5"
          :isPreview="true"
          :fieldData="signatureForm"
          :sectionIndex="0"
          :fieldIndex="1"
          :isDisabled="subTaskStatus == 4 ? 1 : 0"
        />
      </div>
    </b-modal>

    <!-- review modal -->
    <b-modal
      id="modal-1"
      modal-header-close="No"
      :ok-title="$t('training.startCertification')"
      @ok="afterCompleteTraining"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      :title="$t('training.trainingCompleted')"
    >
      <p>{{ $t("training.proceedToExamination") }}</p>
    </b-modal>
    <b-modal
      v-if="!isLinkForm"
      id="historyModal"
      :cancel-title="$t('training.continue')"
      :ok-title="$t('training.fromBeginning')"
      @ok="startSlidesStart"
      no-close-on-backdrop
      v-model="showModal"
      scrollable
      :title="$t('training.continueTraining')"
    >
      <p>
        {{ $t("training.ContinueText1") }} {{ currentSlideIndex + 1 }}
        {{ $t("training.ContinueText2") }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import SectionContainer from "../containers/SectionUserContainer";
import SignaturePad from "../components/templatesConstants/signature";
import AppLoader from "../components/Loader/Loader";
import moment from "moment";
import _ from "lodash";
import { EventBus } from "@/event-bus.js";

import { Helper } from "../helpers";

import { HTTP } from "../utils/HTTP";
import Logo from "../components/logo/logo.vue";

export default {
  name: "UserTrainingPage",
  components: {
    SectionContainer,
    SignaturePad,
    AppLoader,
    Logo,
  },
  data() {
    return {
      showModal: false,
      isLinkForm: false,
      showSignatureModal: false,
      showSig: false,
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      isSliding: false,
      inTransistion: false, // set to true when user selects answer and auto navigates to next slide, used to hide or disable buttons
      pageIntroText: null,
      formTitle: null,
      startTraining: false,
      currentSlideIndex: 0,
      currentSlide: null,
      enabled: true,
      dragging: false,
      selected: "english",
      slides: [],
      slidesWithSelectedLanguage: [],
      signatureForm: null,
      isFullScreen: false,

      // stepper functionility
      noOfSteps: 0,
      isCompletedTraining: false,
      imgProps: {
        height: "calc(100% - 150)",
      },
      taskStatus: null,
      linkedForm: null,
      completedTaskIds: [],
      subTaskStatus: 0,
      subTaskId: null,
      signatureFormTitle: null,
    };
  },

  mounted() {
    console.log("beforeRouteEnter--------");
    this.slidesWithSelectedLanguage = [];
    if (this.$route.query.id) {
      this.isLinkForm = true;
      this.getTrainingSchema(this.$route.query.id);
    } else {
      this.taskStatus = parseInt(localStorage.getItem("activeTaskStatus"));
      let form = JSON.parse(localStorage.getItem("activeFormSchema"));
      this.formTitle = form.formTitle[this.selectedLanguage];
      this.formDescription = form.formDescription[this.selectedLanguage];
      this.pageIntroText = form.formIntroText[this.selectedLanguage];
      this.slides = form.formSection[0].formElements[0].files;
      let lang = this.selectedLanguage;
      this.slides.map((slide) => {
        if (slide[lang]) {
          this.slidesWithSelectedLanguage.push(slide[lang]);
        }
      });
      if (form.linkedTraining && form.linkedTraining.id) {
        // let linkForm = JSON.parse(form.linkedTraining.shcema);
        // this.signatureForm = linkForm.formSection[0].formElements[0];
        this.linkedForm = form.linkedTraining;
      }
      this.currentSlide = this.slidesWithSelectedLanguage[0];
      // this.initializeFormData();

      let activeSlideIndex = parseInt(localStorage.getItem("activeSlideIndex"));

      if (activeSlideIndex != 0) {
        this.showModal = true;
      }

      if (this.taskStatus != 0) {
        this.startTraining = true;
      }

      if (
        activeSlideIndex &&
        activeSlideIndex < this.slidesWithSelectedLanguage.length
      ) {
        this.currentSlideIndex = activeSlideIndex;
      }
    }
  },

  beforeDestroy() {
    // this.onResetLocalData();
    document.removeEventListener("keydown", event);
  },

  beforeRouteLeave(to, from, next) {
    if (this.fromButton) {
      next();
    } else {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  },

  created() {
    // window.addEventListener("beforeunload", this.leaving);
    let self = this;
    document.addEventListener("keydown", function(event) {
      if (
        self.startTraining &&
        event.which == 39 &&
        self.currentSlideIndex + 1 != self.slidesWithSelectedLanguage.length
      ) {
        self.nextslide();
      } else if (
        self.startTraining &&
        event.which == 37 &&
        self.currentSlideIndex != 0
      ) {
        self.previousSlide();
      }
    });
  },

  updated() {},

  watch: {
    currentSlide(value) {},
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    }),
    ...mapState(["selectedAnswersFortrainings"]),
  },

  methods: {
    sanitizeHtml,
    ...mapActions(["setLanguage"]),

    initializeFormData() {
      // console.log("------initializeFormData---------- ", this.signatureForm);
      if (
        this.$store.state.getUserFormSubmitArray &&
        this.$store.state.getUserFormSubmitArray.length
      ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
        // console.log("loading previously saved data....");
      } else {
        // console.log("loading new data....");
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep(this.signatureForm);
        this.$store.state.userFormSubmitArray.push({
          elements: [],
          elementId: this.signatureForm.id,
          elementInputType: this.signatureForm.inputType,
          elementTitle: this.signatureForm.label,
          language: this.selectedLanguage,
        });
      }
      // // console.log("this.$store.state.userFormSubmitArray", this.$store.state.userFormSubmitArray)
    },

    async getTrainingSchema(id) {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let userId = localStorage.getItem("userId");
      let result = await HTTP(
        "get",
        "v1/form/" + id,
        {
          userId: userId,
          formType: 3,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      // console.log("result.data", result.data);
      if (result.data && result.data.form) {
        // this.taskStatus = parseInt(localStorage.getItem("activeTaskStatus"));
        let form = JSON.parse(result.data.form.schema);
        this.formTitle = form.formTitle[this.selectedLanguage];
        this.formDescription = form.formDescription[this.selectedLanguage];
        this.pageIntroText = form.formIntroText[this.selectedLanguage];
        this.slides = form.formSection[0].formElements[0].files;
        if (form.linkedTraining && form.linkedTraining.id) {
          // let linkForm = JSON.parse(form.linkedTraining.shcema);
          // this.signatureForm = linkForm.formSection[0].formElements[0];
          this.linkedForm = form.linkedTraining;
        }
        this.currentSlide = this.slidesWithSelectedLanguage[0];
        // this.initializeFormData();

        let activeSlideIndex = parseInt(
          localStorage.getItem("activeSlideIndex")
        );

        if (activeSlideIndex != 0) {
          this.showModal = true;
        }

        if (this.taskStatus != 0) {
          this.startTraining = true;
        }

        if (activeSlideIndex && activeSlideIndex < this.slides.length) {
          this.currentSlideIndex = activeSlideIndex;
        }
      }
    },

    startSlidesStart() {
      this.currentSlideIndex = 0;
    },

    onStartTraining() {
      this.startTraining = true;
      this.updateTaskStatus(1);
    },

    leaving() {
      alert("Leaving...");
      // window.stop();
    },

    onResetLocalData() {
      localStorage.removeItem("taskId");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("activeTaskStatus");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("examAttemptId");
      localStorage.removeItem("tempForm");
    },

    autoNextslide() {
      this.inTransistion = true;
      setTimeout(() => {
        this.nextslide();
        this.inTransistion = false;
      }, 1000);
    },

    onBack() {
      this.fromButton = true;
      this.saveActiveSlide();
      this.$router.push("/my-training");
    },

    nextslide() {
      if (this.currentSlideIndex + 1 < this.slidesWithSelectedLanguage.length) {
        this.currentSlideIndex++;
        this.currentslide = this.slidesWithSelectedLanguage[
          this.currentSlideIndex
        ];
        localStorage.setItem("activeSlideIndex", this.currentSlideIndex);
      }
    },

    async saveActiveSlide() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let taskId = localStorage.getItem("taskId");
      let slideStatus = this.currentSlideIndex + 1;

      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/training/active-slide/" + taskId,
          {
            slideStatus: slideStatus,
          },
          {
            Authorization: token,
          },
          null,
          true
        );

        localStorage.setItem("activeSlideIndex", this.currentSlideIndex);
      } catch (error) {
        // console.log("error", error);
      }
    },

    async updateTaskStatus(status) {
      let taskStatus = status;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let taskId = localStorage.getItem("taskId");

      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/status/" + taskId,
          {
            taskStatus: taskStatus,
          },
          {
            Authorization: token,
          },
          null,
          true
        );

        localStorage.setItem("activeTaskStatus", 1);
        this.taskStatus = status;
      } catch (error) {
        // console.log("error", error);
      }
    },

    previousSlide() {
      this.currentSlideIndex--;
      this.currentslide = this.slidesWithSelectedLanguage[
        this.currentSlideIndex
      ];
      localStorage.setItem("activeSlideIndex", this.currentSlideIndex);
    },

    onOpenSignatureModal() {
      if (this.linkedForm && this.linkedForm.id) {
        this.getFormSchema();
      } else {
        this.onCompleteTraining();
      }
    },

    async getFormSchema() {
      // // console.log("getFormSchema", this.linkedForm)
      let onboardingId = localStorage.getItem("activeOnboardingId");
      try {
        let result = await HTTP("post", "v1/get/form/with/task", {
          formId: this.linkedForm.id,
          onboardingId: onboardingId,
        });
        // // console.log("getFormSchema dtaa", result.data)
        let linkedForm = JSON.parse(result.data.form.schema);
        // // console.log("linkedForm", linkedForm)
        this.signatureFormTitle = linkedForm.formTitle;
        this.subTaskStatus = result.data.task_status;
        this.subTaskId = result.data.taskId;
        this.signatureForm = linkedForm.formSection[0].formElements[0];
        // // console.log("result.data.form_data", typeof(result.data.form_data))
        let form_data =
          typeof result.data.form_data == "string"
            ? JSON.parse(result.data.form_data)
            : [];
        if (
          form_data &&
          form_data.hasOwnProperty("user_data") &&
          this.subTaskStatus == 4
        ) {
          // // console.log("result.data.task.form", form_data.user_data);
          this.$store.state.getUserFormSubmitArray = form_data.user_data;
        }
        this.initializeFormData();
        this.showSignatureModal = true;
        this.onShowSig();
      } catch (error) {
        // console.log("error----getFormSchema", error);
      }
    },

    resetModal() {
      this.showSignatureModal = false;
      this.showSig = false;
    },

    onValidateSignature() {
      EventBus.$emit("onSubmitEndUserForm", "form training");
      this.getInvalidFields();
      // this.checkForInValidFields();
    },

    getInvalidFields() {
      // console.log(
      //   ":getInvalidFields -------------",
      //   this.$store.state.validFields
      // );
      if (this.$store.state.validFields) {
        this.onSubmitSubTask();
      } else {
        this.showSignatureModal = true;
      }
    },

    async onSubmitSubTask() {
      // console.log("onSubmitSubTask", this.taskStatus);
      let userId = localStorage.getItem("userId");
      let taskId = localStorage.getItem("taskId");
      let parentTaskId = localStorage.getItem("activeFormId");
      let oncompleteTaskIds = localStorage.getItem("rekatedTaskIds");
      let onboardingId = localStorage.getItem("activeOnboardingId");
      let formDefaultLanguage = localStorage.getItem("formDefaultLanguage");
      let taskData = this.$store.state.userFormSubmitArray;
      // /v1/mytpp/task/training/status/
      if (this.taskStatus != 4 || this.subTaskStatus != 4) {
        let token = "Bearer " + localStorage.getItem("accessToken");

        try {
          let result = await HTTP(
            "post",
            "v1/mytpp/subtask/submit",
            {
              status: 4,
              userId: userId,
              taskId: this.subTaskId,
              taskData: taskData,
              parentFormId: parentTaskId,
              oncompleteTaskIds: oncompleteTaskIds,
              onboardingId: onboardingId,
              formDefaultLanguage: formDefaultLanguage,
              formType: 8,
            },
            {
              Authorization: token,
            },
            null,
            true
          );
          this.fromButton = true;
          // console.log("submitttt", result);
          if (result.status == 200) {
            this.onCompleteTraining();
          }
        } catch (error) {
          // console.log("error", error);
        }
      } else {
        this.fromButton = true;
        // this.$router.push("my-training");
      }
    },

    async onCompleteTraining() {
      let userId = localStorage.getItem("userId");
      let taskId = localStorage.getItem("taskId");
      let formDefaultLanguage = localStorage.getItem("formDefaultLanguage");
      let taskData = this.$store.state.userFormSubmitArray;
      // /v1/mytpp/task/training/status/
      if (this.taskStatus != 4) {
        let token = "Bearer " + localStorage.getItem("accessToken");
        let taskId = localStorage.getItem("taskId");

        try {
          let result = await HTTP(
            "post",
            "v1/mytpp/task/training/status/" + taskId,
            {
              taskStatus: 4,
              userId: userId,
              taskData: taskData,
              formDefaultLanguage: formDefaultLanguage,
            },
            {
              Authorization: token,
            },
            null,
            true
          );
          this.fromButton = true;
          // // console.log("this.form.linkedExam", this.form.linkedExam);
          if (this.form.linkedExam && this.form.linkedExam.id) {
            this.$bvModal.show("modal-1");
          } else {
            this.$router.replace("my-training");
          }
        } catch (error) {
          // console.log("error", error);
        }
      } else {
        this.fromButton = true;
        this.$router.push("my-training");
      }
    },

    async afterCompleteTraining() {
      if (this.form.linkedExam && this.form.linkedExam.id) {
        let userId = "Bearer " + localStorage.getItem("userId");
        let taskId = this.form.linkedExam.id;
        let formType = 4;
        // this.$router.push('my-certifications')
        let token = "Bearer " + localStorage.getItem("accessToken");
        try {
          let result = await HTTP(
            "post",
            "v1/mytpp/task/" + taskId,
            {
              userId: userId,
              formType: formType,
            },
            {
              Authorization: token,
            },
            null,
            true
          );

          if (result.data.task && result.data.task) {
            // alert(result.data.task.task_status);
            let form = result.data.task.form.schema;
            let form_data = JSON.parse(result.data.task.form_data);
            this.$store.state.userFormSubmitArray = form_data;
            localStorage.setItem("activeFormId", formId);
            localStorage.setItem("activeFormSchema", form);
            localStorage.setItem(
              "activeTaskStatus",
              result.data.task.task_status
            );

            this.$router.replace("/user-exam");
          }
        } catch (err) {
          // console.log("errr---", err);
        }
      } else {
        // this.$router.replace("my-training");
        this.$router.replace("my-certifications");
      }
    },

    //method to toggle full screen mood
    toggleFullScreen() {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    onShowSig() {
      setTimeout(() => {
        this.showSig = true;
      }, 400);
    },
  },
};
</script>

<style>
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 290px);
  /* height:400px */
}

.selectPicket {
  width: 350px;
}

.animate-slide-from-left {
  position: relative;
  animation: fromLeft 2s;
  opacity: 1;
}

.animate-slide-to-right {
  position: relative;
  animation: toRight 0.5s;
  opacity: 1;
}

@keyframes fromLeft {
  from {
    left: -50px;
    opacity: 0;
  }

  to {
    left: 0;
    opacity: 1;
  }
}

@keyframes toRight {
  from {
    left: 0;
    opacity: 1;
  }

  to {
    left: 150px;
    opacity: 0;
  }
}

.first {
  width: 20rem;
  height: 40px;
  background: #33dd97;
  position: absolute;
}

#talkbubble {
  margin-top: 45px;
  width: 20rem;
  height: 12rem;
  background: #33dd97;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

#talkbubble:before {
  content: "";
  position: absolute;
  right: 9rem;
  top: 12rem;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 25px solid #33dd97;
  border-left: 12px solid transparent;
}

.modal-container {
  margin: 5px;
}
</style>
